import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createInvoiceAction } from "../actions/create-invoice";
import { ICreateInvoicePayload } from "../interfaces/invoice.interfaces";
import { useSelector } from "react-redux";

export const useCreateInvoiceMutation = () => {
  const queryClient = useQueryClient();
  const { company } = useSelector((state: any) => state.userState);

  return useMutation({
    mutationFn: (invoice: ICreateInvoicePayload) => {
      if (!company?.id) {
        throw new Error("Company ID is required");
      }
      return createInvoiceAction(invoice, company.id);
    },
    onSuccess: (data, variables) => {
      // Invalidate general invoice queries
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      queryClient.invalidateQueries({ queryKey: ["jobs"] });

      const billedUids =
        variables.billingJobEvents?.map((e) => e.uid).filter(Boolean) ??
        (variables.jobEventUid ? [variables.jobEventUid] : []);
      billedUids.forEach((uid) => {
        queryClient.invalidateQueries({ queryKey: ["invoices", "by-job-event", uid] });
      });

      if (variables.jobEventUid) {
        queryClient.invalidateQueries({ queryKey: ["invoice", variables.jobEventUid] });
      }
      variables.billingJobEvents?.forEach((e) => {
        if (e.uid) queryClient.invalidateQueries({ queryKey: ["invoice", e.uid] });
      });

      if (data?.uid) {
        queryClient.invalidateQueries({ queryKey: ["invoice", data.uid] });
      }
    },
    onError: (error: any) => {
      console.error("[useCreateInvoiceMutation] Error creating invoice:", error);
    },
  });
};
